import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { AdjustableHeight } from '../utils/splide-auto-height';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.testimonials__items');

  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'fade',
      rewind: true,
      direction: 'ltr',
      perPage: 1,
      perMove: 1,
      fade: true,
      arrows: true,
      keyboard: 'global',
      pagination: false,
      drag: true,
      focus: 0,
      adjustableHeight: {
        whileSliding: true,
        speed: '0.4s',
      },
    });

    splide.mount({ AdjustableHeight });
  }
});
